import React, {useEffect, useMemo, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import BasicTable from '../Components/Global_Components/reacttable/table';
import '../styles/Patients.scss';

import {Tooltip as ReactTooltip} from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import Swal from 'sweetalert2';
import AddPatient_form from '../Components/AddPatient_form';
import EditPatient_form from '../Components/EditPatient_form';
import {patientid, reportViewId, reportViewType, sidebar} from '../Redux/Slice/rootSlice';
import {deletePatientBill, fetchPatientBill, getArchiveData, postPatientBillMsg} from '../Redux/Thunk/Actions';
// import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import {TextField} from '@mui/material';
import {LocalizationProvider} from '@mui/x-date-pickers-pro';
import {AdapterDayjs} from '@mui/x-date-pickers-pro/AdapterDayjs';
import {DateRangePicker} from '@mui/x-date-pickers-pro/DateRangePicker';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
dayjs.extend(localizedFormat);

function PatientBilling({loaderchange, enableditview, popupalert, popuptext}) {
  const [tableheaderdata, settableheaderdata] = useState([]);
  const userdata = useSelector(state => state.counter.userdata);
  const [datacount, setdatacount] = useState();
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [update, setUpdate] = useState('');
  const viewpatient = useNavigate();
  const sideactive = useSelector(state => state.counter.sidebarnav);
  const createpageReport = useSelector(state => state.counter.patientReportCreateredux);
  const [branches, setbranches] = useState(() => localStorage.getItem('selectedBranch') || localStorage.getItem('branch') || '');
  const [todaysTotal, setTodaysTotal] = useState(0);
  const [initialBillDate, setInitialBillDate] = useState('');
  const [alert, setalert] = useState(false);
  const edituser = useSelector(state => state.counter.edituser);
  const adminuser = useNavigate();
  const [changeAlert, setChangeAlert] = useState(false);
  // const [roledata, setroledata] = useState("");
  const roledata = 'Super Admin';
  const [closeCreatePopup, setCloseCreatePopup] = useState(false);
  const [closeEditPopup, setCloseEditPopup] = useState(false);
  const [error, seterror] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchQuery, setSearchQuery] = useState('');
  const [search, setsearch] = useState(false);
  const [startDate, setStartDate] = useState(dayjs().format('YYYY-MM-DD'));
  const dateStr = '2024-01-23T10:45:42.716334Z';
  const formattedDate = dayjs(dateStr).format('YYYY-MM-DD');
  const [endDate, setEndDate] = useState(dayjs().format('YYYY-MM-DD'));
  const [wawlwsjkf, setwawlwsjkf] = useState(true);
  const [MsgPopUp, setMsgPopUp] = useState(false);

  const [deleteId, setDeleteId] = useState('');
  const [remarkMsg, setRemarkMsg] = useState('');
  const [tableArchive, setTableArchive] = useState(false);
  const [remarkError, setRemarkError] = useState(false);
  const [session, setSession] = useState('');

  const [patientReportCreate, setPatientReportCreate] = useState(createpageReport);

  // Calculate current page total for display in table footer
  const [currentPageTotal] = useMemo(() => {
    let total = 0;
    tableheaderdata.forEach(item => {
      // Debug: Check what fields are available
      console.log('Item fields:', Object.keys(item));
      console.log('bill_price value:', item.bill_price, 'type:', typeof item.bill_price);

      // Try different possible field names for bill amount
      const billAmount = item.bill_price || item.total_bill || item.amount || item.total || 0;
      total += Math.round(Number(billAmount) || 0);
    });
    console.log('Current page total calculated:', total);
    return [total];
  }, [tableheaderdata]);

  const dropdownhandlechange = (e, event) => {
    if (e) {
      dispatch(reportViewType('Patient Billing'));
      viewpatient('/reportview');
      dispatch(reportViewId(e));
    }
  };
  // const deletePatientBillPopup = (e, event) => {
  //   setConfirmDeletePop(true)
  //   setDeleteId(e)
  // }

  const confirmDelete = async e => {
    if (remarkMsg.trim() == '') {
      setRemarkError(true);
      return;
    }
    console.log(remarkMsg);
    setMsgPopUp(false);
    const payload = {
      rme: {
        remarks: remarkMsg
      },
      id: deleteId
    };
    console.log(deleteId, 'idddddd');
    const msgResponse = postPatientBillMsg(payload);
    const response = await dispatch(msgResponse);
    console.log(response, 'daniel');

    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete this bill',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then(async result => {
      if (result.isConfirmed) {
        await dispatch(deletePatientBill(deleteId));
        setDeleteId(null);
        Swal.fire({
          title: 'Deleted!',
          text: 'Your file has been deleted.',
          icon: 'success'
        });
      }
    });

    // setConfirmDeletePop(false)
  };

  const cancelMsg = (id, event) => {
    setDeleteId(id);
    setMsgPopUp(true);
  };

  // *currenTableData
  const currentableData = async e => {
    if (e.target.value === 'all') {
      setTableArchive(false);
      setSearchQuery('');
    } else {
      setTableArchive(true);
      setSearchQuery('');
    }
  };

  //  const currentableData = async (e)=>{
  //   // loaderchange(true)
  //   const dataPayload = {
  //     page: dtpageindex,
  //     page_size: dtpagesize,
  //     search: searchQuery,
  //     from_date: startDate,
  //     to_date: endDate,
  //     range: true,
  //   };
  //   if(e.target.value==="archived"){
  //     setTableArchive(true)
  //     const responseArchivedDetails = await dispatch(getArchiveData())

  //     if(responseArchivedDetails?.payload?.status?.code == 200){
  //       settableheaderdata(responseArchivedDetails.payload.data)
  //     }
  //     // loaderchange(false)

  //   }
  //   else if(e.target.value==="all"){
  //     setTableArchive(false)
  //     const responseAllDetails = await dispatch(fetchPatientBill(dataPayload))
  //     console.log(responseAllDetails.payload.data.data,"all");
  //     if(responseAllDetails?.payload?.status?.code == 200){
  //       settableheaderdata(responseAllDetails.payload.data.data)
  //     }
  //     // loaderchange(false)

  //  }
  // }

  // const update = async () => {
  //   const dataInitPayload = {
  //     page: dtpageindex,
  //     page_size: dtpagesize,
  //     search: searchQuery,
  //     from_date: dayjs().format("YYYY-MM-DD"),
  //     to_date: dayjs().format("YYYY-MM-DD"),
  //     range: true,
  //   };
  //   const patentDetailss = fetchPatientBill(dataInitPayload);
  //   const responsePatentDetailss = await dispatch(patentDetailss);
  //   if (responsePatentDetailss?.payload?.status?.code === 200) {
  //     setTodaysTotal(responsePatentDetailss.payload.data.total_bill_price);
  //     setwawlwsjkf(false);
  //   }
  // };
  const updateData = async () => {
    const dataInitPayload = {
      page: dtpageindex,
      page_size: dtpagesize,
      search: searchQuery,
      from_date: dayjs().format('YYYY-MM-DD'),
      branch: branches,
      // to_date: dayjs().format("YYYY-MM-DD"),
      range: false
    };
    const patentDetailss = fetchPatientBill(dataInitPayload);
    const responsePatentDetailss = await dispatch(patentDetailss);
    if (responsePatentDetailss?.payload?.status?.code === 200) {
      setTodaysTotal(responsePatentDetailss.payload.data.total_bill_price);
      setwawlwsjkf(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const dataPayload = {
        page: dtpageindex,
        page_size: dtpagesize,
        search: searchQuery,
        branch: branches,
        from_date: startDate,
        to_date: endDate,
        range: true,
        session: session
      };

      // const dataInitPayload = {
      //   page: dtpageindex,
      //   page_size: dtpagesize,
      //   search: searchQuery,
      //   from_date: dayjs().format("YYYY-MM-DD"),
      //   // to_date: dayjs().format("YYYY-MM-DD"),
      //   range: false,
      // };
      loaderchange('true');
      // const payload = wawlwsjkf ? dataInitPayload : dataPayload;

      const patentDetails = fetchPatientBill(dataPayload);
      const responsePatentDetails = await dispatch(patentDetails);
      if (responsePatentDetails?.payload?.status?.code === 200) {
        setdatacount(responsePatentDetails.payload.total_count);
        settableheaderdata(responsePatentDetails.payload.data.data);
        setTodaysTotal(responsePatentDetails.payload.data.total_bill_price);
        if (!setwawlwsjkf) {
          setTodaysTotal(responsePatentDetails.payload.data.total_bill_price);
        }
        setInitialBillDate(dayjs(responsePatentDetails.payload.data.first_date).format('YYYY-MM-DD'));
        loaderchange('false');
        setwawlwsjkf(false);
      } else {
        loaderchange('false');
        popupalert('true');
        popuptext('No Data Available');
        setTimeout(() => {
          popupalert('false');
        }, 2000);
      }
    };
    // *---------------------------------------
    const fetchArchiveData = async e => {
      // loaderchange(true)
      const dataPayload = {
        page: dtpageindex,
        page_size: dtpagesize,
        search: searchQuery,
        branch: branches,
        from_date: startDate,
        to_date: endDate,
        range: true,
        session: session
      };

      const responseArchivedDetails = await dispatch(getArchiveData(dataPayload));

      if (responseArchivedDetails?.payload?.status?.code == 200) {
        settableheaderdata(responseArchivedDetails.payload.data);
      }
    };
    // *---------------------------------------
    if (tableArchive) {
      fetchArchiveData();
    } else {
      fetchData();
    }

    if (searchQuery != '') {
      const hasNumbers = /[0-9]/.test(searchQuery);
      const hasLetters = /[a-zA-Z]/.test(searchQuery);
      const hasSpecialChars = /[!@#$%^&*()_+{}\[\]:;<>,.?~\\-]/.test(searchQuery);
      if (hasNumbers || hasLetters || hasSpecialChars) {
        if (tableArchive) {
          fetchArchiveData();
        } else {
          fetchData();
        }
      }
    } else {
      if (tableArchive) {
        fetchArchiveData();
      } else {
        fetchData();
      }
    }
  }, [dtpageindex, dtpagesize, search, searchQuery, branches, update, startDate, deleteId, endDate, tableArchive, todaysTotal, session]);

  const fetchDataToday = async (start, end) => {
    const dataInitPayload = {
      page: dtpageindex,
      page_size: dtpagesize,
      search: searchQuery,
      branch: branches,
      from_date: start,
      to_date: end,
      range: true
    };
    const patentDetails = fetchPatientBill(dataInitPayload);
    const responsePatentDetails = await dispatch(patentDetails);
    if (responsePatentDetails?.payload?.status?.code === 200) {
      setTodaysTotal(responsePatentDetails.payload.data.total_bill_price);
      setwawlwsjkf(false);
    }
  };
  useEffect(() => {
    const fetchDataTodays = async () => {
      const dataInitPayload = {
        page: dtpageindex,
        page_size: dtpagesize,
        search: searchQuery,
        branch: branches,
        from_date: startDate,
        to_date: endDate,
        range: true
      };
      const patentDetails = fetchPatientBill(dataInitPayload);
      const responsePatentDetails = await dispatch(patentDetails);
      if (responsePatentDetails?.payload?.status?.code === 200) {
        setTodaysTotal(responsePatentDetails.payload.data.total_bill_price);
        setwawlwsjkf(false);
      }
    };

    fetchDataTodays();
  }, []);
  const columns = useMemo(
    () => [
      {
        Header: 'Patient Name',
        accessor: '',
        Cell: row => {
          // console.log(row.row.original.username)
          return (
            <>
              <span>
                <div style={{marginTop: '3px'}} data-tooltip-id='my-tooltip' data-tooltip-content={String(row.row.original.patient_name)}>
                  {row.row.original.patient_id != null ? row.row.original.patient_id.titles + '.' + row.row.original.patient_id.first_name + '   ' + row.row.original.patient_id.last_name : '--'}
                </div>
              </span>
            </>
          );
        }
      },

      {
        Header: 'Created by',
        accessor: '',
        Cell: row => {
          // console.log(row.row.original.username)
          return (
            <>
              <span>
                <div style={{marginTop: '3px'}} data-tooltip-id='my-tooltip' data-tooltip-content={String(row.row.original.user_id.user_name)}>
                  {String(row.row.original.user_id.user_name)}
                </div>
              </span>
            </>
          );
        }
      },
      {
        Header: 'Date',
        accessor: '',
        Cell: row => {
          const final_value = row.row.original.created_at.slice(0, 10);
          const [year, month, day] = final_value.split('-');
          const formattedDate = `${day}-${month}-${year}`;
          return (
            <>
              <span>
                <div style={{marginTop: '3px'}} data-tooltip-id='my-tooltip' data-tooltip-content={String(formattedDate)}>
                  {String(formattedDate)}
                </div>
              </span>
            </>
          );
        }
      },
      {
        Header: 'Time',
        accessor: '',
        Cell: row => {
          // const inputDateTime = "2023-11-08T07:35:00.730468Z";
          // const date = new Date(inputDateTime);
          // const hours = date.getHours();
          // const minutes = date.getMinutes();
          // const formattedHours = hours.toString().padStart(2, "0");
          // const formattedMinutes = minutes.toString().padStart(2, "0");
          // const time = `${formattedHours}:${formattedMinutes}`;
          const date = new Date(row.row.original.created_at);
          const hours = date.getHours();
          const minutes = date.getMinutes();
          const amOrPm = hours >= 12 ? 'PM' : 'AM';
          let formattedHours = (hours % 12).toString().padStart(2, '0');
          formattedHours = formattedHours === '00' ? '12' : formattedHours;
          const formattedMinutes = minutes.toString().padStart(2, '0');
          const time = `${formattedHours}:${formattedMinutes} ${amOrPm}`;
          return (
            <>
              <span>
                <div style={{marginTop: '3px'}} data-tooltip-id='my-tooltip' data-tooltip-content={String(time)}>
                  {String(time)}
                </div>
              </span>
            </>
          );
        }
      },
      {
        Header: 'Session',
        accessor: '',
        Cell: row => {
          const date = new Date(row.row.original.created_at);
          const hours = date.getHours();
          const minutes = date.getMinutes();
          const timeInMinutes = hours * 60 + minutes;

          // Morning: 6:00 AM – 4:30 PM (06:00 - 16:30)
          // Evening: 4:31 PM – 11:30 PM (16:31 - 23:30)
          const morningStart = 6 * 60; // 6:00 AM
          const morningEnd = 16 * 60 + 30; // 4:30 PM
          const eveningEnd = 23 * 60 + 30; // 11:30 PM

          let sessionType = '';
          if (timeInMinutes >= morningStart && timeInMinutes <= morningEnd) {
            sessionType = 'Morning';
          } else if (timeInMinutes > morningEnd && timeInMinutes <= eveningEnd) {
            sessionType = 'Evening';
          } else {
            sessionType = '--';
          }

          return (
            <>
              <span>
                <div style={{marginTop: '3px'}} data-tooltip-id='my-tooltip' data-tooltip-content={sessionType}>
                  {sessionType}
                </div>
              </span>
            </>
          );
        },
        Footer: () => <span style={{fontWeight: 'bold'}}>TOTAL</span>
      },
      {
        Header: 'Notes',
        accessor: '',
        Cell: row => {
          // console.log(row.row.original.username)
          return (
            <>
              <span>
                <div style={{marginTop: '3px'}} data-tooltip-id='my-tooltip' data-tooltip-content={String(row.row.original.description)}>
                  {row.row.original.description == null || row.row.original.description.length == 0 ? '--' : row.row.original.description}
                </div>
              </span>
            </>
          );
        }
      },
      {
        Header: 'Mode of Payment',
        accessor: '',
        Cell: row => {
          // console.log(row.row.original.username)
          const lst = [];
          console.log(row.row.original);
          if (row.row.original['mode_one'] != null) {
            lst.push(row.row.original['mode_one']);
          }
          if (row.row.original['mode_two'] != null) {
            lst.push(row.row.original['mode_two']);
          }
          if (row.row.original['mode_three'] != null) {
            lst.push(row.row.original['mode_three']);
          }
          if (row.row.original['mode_four'] != null) {
            lst.push(row.row.original['mode_four']);
          }

          return (
            <>
              <span>
                {lst.map(e => {
                  return (
                    <div data-tooltip-id='my-tooltip' data-tooltip-content={String(e)}>
                      {e}
                    </div>
                  );
                })}
              </span>
            </>
          );
        }
      },
      {
        Header: 'Total Bill',
        accessor: '',
        Cell: row => {
          // console.log(row.row.original.username)
          return (
            <>
              {row.row.original.bill_price}
              {/* {todaysTotal} */}
            </>
          );
        },
        Footer: () => <span>{currentPageTotal && Math.round(currentPageTotal)}</span>
      },
      {
        // * delete table icon
        Header: tableArchive ? 'Remarks' : 'Actions',

        accessor: '',
        Cell: row => {
          if (tableArchive) {
            return (
              <div className='style' style={{width: '150px', height: '50px', overflow: 'scroll'}}>
                <div data-tooltip-id='my-tooltip' data-tooltip-content={String(row.row.original.remarks)}>
                  {row.row.original.remarks}
                </div>
              </div>
            );
          } else {
            return (
              <div className='style'>
                <button type='button' class='btn btn-danger btn-sm delete' style={{display: 'flex', gap: '4px'}} onClick={e => dropdownhandlechange(row.row.original.id, e)}>
                  <i onClick={e => dropdownhandlechange(row.row.original.id, e)} class='bi bi-eye-fill'></i> View
                </button>
                {/* {userdata.role ==="Admin" &&( */}
                <button type='button' class='btn btn-danger btn-sm trash' style={{display: 'flex', gap: '4px'}} onClick={e => cancelMsg(row.row.original.id, e)}>
                  <i onClick={e => cancelMsg(row.row.original.id, e)} class='bi bi-x-circle'></i> Cancel
                </button>
                {/* )} */}
              </div>
            );
          }
        }
      }
    ],
    [tableArchive, currentPageTotal]
  );

  const createPatientReport = e => {
    navigate('/bill_create');
  };
  const editPatientPopup = e => {
    dispatch(patientid(e));
    setCloseEditPopup(true);
  };

  const [finalPatientsData, setFinalPatientsData] = useState('');

  const pagesize = arg => {
    setdtPagesize(arg);
  };

  const pageindex = arg => {
    setdtPageindex(arg);
  };
  const handleSubmit = event => {
    event.preventDefault();
  };

  const patientId = useSelector(state => state.counter.patientid);

  const [value, setValue] = React.useState([dayjs(), dayjs()]);

  return (
    <div className={sideactive ? 'maincontainer-patient-sa' : 'maincontainer-patient'}>
      {closeCreatePopup && <AddPatient_form setCloseCreatePopup={setCloseCreatePopup} loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} setUpdate={setUpdate} />}
      {closeEditPopup && <EditPatient_form setCloseEditPopup={setCloseEditPopup} loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} setUpdate={setUpdate} />}
      <div className='patient-header'>
        <div className='row'>
          <div className='col'>
            <h3 className='page-title'>Patient Billing</h3>
            <ul className='breadcrumb'>
              <li className='breadcrumb-item'>
                <a
                  href='/'
                  style={{textDecoration: 'none', color: 'black'}}
                  onClick={e => {
                    dispatch(sidebar('DashBoard'));
                  }}>
                  Dashboard
                </a>
              </li>
              <li className='breadcrumb-item active'>Patient Billing</li>
            </ul>
          </div>
        </div>

        <div className='add_btn'>
          <button onClick={e => createPatientReport(e)} className='btn_1'>
            Create Bill
          </button>
        </div>
      </div>
      {userdata.role === 'Admin' && (
        <div className='billableCard'>
          <p>
            {startDate === dayjs().format('YYYY-MM-DD') && endDate === dayjs().format('YYYY-MM-DD') ? "Today's Billing Overview" : 'Billing Overview'}
            &nbsp;:&nbsp;
            <span>{todaysTotal ?? 0}&nbsp;Rs</span>
          </p>
        </div>
      )}
      <div className='row' style={{marginTop: 20}}>
        <div className='col-lg-12'>
          <div className='card'>
            <div className='card-body'>
              <div className='patient'>
                <div className='table-content-patient'>
                  <form onSubmit={handleSubmit} style={{display: 'flex', justifyContent: 'space-between'}}>
                    <div class='input-group rounded' style={{width: '250px', height: '40px'}}>
                      <input
                        type='search'
                        class='form-control rounded'
                        aria-label='Search'
                        aria-describedby='search-addon'
                        value={searchQuery}
                        style={{
                          height: '40px'
                        }}
                        onKeyDown={e => {
                          if (e.target.value.length === 0 && e.which === 32) {
                            e.preventDefault();
                          }
                        }}
                        onInput={e => {
                          if (e.target.value.length <= '100') {
                            setSearchQuery(e.target.value);
                          } else {
                            e.preventDefault();
                          }
                        }}
                        // onKeyDown={(e)=>{if(e.which=="32"){
                        //   e.preventDefault()
                        // }}}

                        min='0'
                        max='10'
                        label='Search'
                        placeholder='Search...'
                        required
                      />

                      <span class='input-group-text border-0 bg-transparent p-0' id='search-addon'>
                        <i
                          class='bi bi-search'
                          style={{
                            color: '#1b5a90',
                            width: '20px',
                            height: '20px',
                            marginLeft: '10px'
                          }}></i>
                      </span>
                    </div>
                    <div>
                      <select className='form-select' onChange={currentableData}>
                        <option value='all'>All</option>
                        <option value='archived'>Cancelled</option>
                      </select>
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        gap: '10px'
                      }}>
                      <select
                        name='session'
                        style={{width: '150px', height: '40px', marginRight: '40px'}}
                        className='form-control rounded'
                        onChange={e => {
                          setSession(e.target.value);
                        }}>
                        <option selected value=''>
                          Session
                        </option>
                        <option value='morning'>Morning</option>
                        <option value='evening'>Evening</option>
                      </select>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DateRangePicker
                          startText='Check-in'
                          endText='Check-out'
                          value={value}
                          onChange={newValue => {
                            setValue(newValue);
                            if (newValue[0] && newValue[1]) {
                              setUpdate(false);
                              setStartDate(dayjs(newValue[0]).format('YYYY-MM-DD'));
                              setEndDate(dayjs(newValue[1]).format('YYYY-MM-DD'));
                              fetchDataToday(dayjs(newValue[0]).format('YYYY-MM-DD'), dayjs(newValue[1]).format('YYYY-MM-DD'));
                            }
                          }}
                          minDate={dayjs('2021-03-21')}
                          maxDate={dayjs()} // Sets the max date to today
                          renderInput={(startProps, endProps) => (
                            <>
                              <TextField
                                {...startProps}
                                InputLabelProps={{
                                  shrink: true
                                }}
                                inputProps={{
                                  ...startProps.inputProps,
                                  value: startProps.inputProps.value ? dayjs(startProps.inputProps.value).format('DD-MM-YYYY') : ''
                                }}
                              />
                              <TextField
                                {...endProps}
                                InputLabelProps={{
                                  shrink: true
                                }}
                                inputProps={{
                                  ...endProps.inputProps,
                                  value: endProps.inputProps.value ? dayjs(endProps.inputProps.value).format('DD-MM-YYYY') : ''
                                }}
                              />
                            </>
                          )}
                        />
                      </LocalizationProvider>
                    </div>
                  </form>

                  <div className='table-patient'>
                    <BasicTable columns={columns} data={tableheaderdata} pagesize={pagesize} pageindex={pageindex} dtpagesize={dtpagesize} dtpageindex={dtpageindex} datacount={datacount} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {MsgPopUp && (
        <div className='reasonPopUpContainer'>
          <div className='reasonPopUp'>
            <h3>Reason For Cancel</h3>
            <textarea class='form-control' id='inputAddress' placeholder='Enter the message' onInput={e => setRemarkMsg(e.target.value)}></textarea>
            {/* {false && (<span>Remarks Required</span>)} */}
            <section>
              <button type='button' class='btn btn-primary' onClick={() => setMsgPopUp(false)}>
                Exit
              </button>
              <button type='button' class='btn btn-danger' onClick={confirmDelete}>
                Proceed
              </button>
            </section>
          </div>
        </div>
      )}
      <ReactTooltip
        id='my-tooltip'
        arrowColor='transparent'
        place='bottom-start'
        delayShow={200}
        style={{
          backgroundColor: '#707070',
          fontSize: '10px',
          textAlign: 'center',
          padding: '5px',
          fontSize: '14',
          fontWeight: 400
        }}
      />
    </div>
    // <></>
  );
}
export default PatientBilling;
